/**
 * @generated SignedSource<<dd488192ca57a1c58d8c041d0f83e03a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueResults_viewResult$data = {
  readonly __typename: "QueryError";
  readonly extensions?: ReadonlyArray<{
    readonly statusCode: number | null | undefined;
  }> | null | undefined;
  readonly message?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_view">;
  readonly " $fragmentType": "main_issueNavigator_IssueResults_viewResult";
};
export type main_issueNavigator_IssueResults_viewResult$key = {
  readonly " $data"?: main_issueNavigator_IssueResults_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueResults_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueResults_viewResult",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_ListView_view"
        }
      ],
      "type": "JiraIssueSearchView"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "message"
        },
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ],
      "type": "QueryError"
    }
  ],
  "type": "JiraIssueSearchViewResult",
  "abstractKey": "__isJiraIssueSearchViewResult"
};

(node as any).hash = "362ba93c6ea156e17c2f613c7a350a18";

export default node;
